import React, { ReactNode, useContext } from 'react'
import {
  AngleNavbar,
  Avatar,
  UserDropdown,
  Logo,
  Badge
} from 'react-angle-dashboard-components'
import { useHistory, useLocation } from 'react-router-dom'
import { AuthContext } from '../context/Auth/AuthContext'
import SubNavbar from './SubNavbar'
import Breadcrumb from './Breadcrumb'
import { Paths } from '../routes/paths'

export const Layout: React.FC<{
  showUserDropdown?: boolean
  hideBarItems?: boolean
  breadcrumbs?: {
    link: string
    title: string
  }[]
  RightSubNavElement?: ReactNode
}> = ({
  children,
  showUserDropdown = false,
  hideBarItems = false,
  breadcrumbs,
  RightSubNavElement
}) => {
  const history = useHistory()
  const location = useLocation()
  const { logout, userData: user } = useContext(AuthContext)

  let initials = ''
  if (user) {
    initials =
      (user?.first_name[0] || '').toUpperCase() +
      (user?.last_name[0] || '').toUpperCase()
  }
  const avatarImg = (
    <Avatar
      style={{ top: '2px' }}
      circle
      border="lg"
      size="sm"
      fallbackContent={initials}
      customBg="#28347E"
    />
  )

  const dropdownItems = [
    {
      title: 'Sign Out',
      icon: 'sign-out',
      callback: async () => {
        await logout()
      },
      iconClass: 'text-danger'
    }
  ]

  let username = user ? user?.first_name + ' ' + user?.last_name : ''
  const avatar = (
    <div>
      <UserDropdown
        avatar={avatarImg}
        items={dropdownItems}
        userName={username}
        email={user?.username || ''}
      />
    </div>
  )

  let navBarOffsetMargin = 75

  if (breadcrumbs) {
    navBarOffsetMargin += 48
  }

  let barItems = [
    {
      title: 'Book of Business',
      onClick: () => {
        history.push(Paths.home)
      },
      active: location.pathname === Paths.home
    },
    {
      title: 'Benefit Builder',
      titleBadge: (
        <Badge
          className="ml-2"
          style={{
            backgroundColor: '#0099AE'
          }}
        >
          BETA
        </Badge>
      ),
      onClick: () => {
        history.push(Paths.quotes)
      },
      active: location.pathname.includes(Paths.quotes)
    }
  ]

  if (hideBarItems) {
    barItems = []
  }

  return (
    <div>
      <AngleNavbar
        items={barItems}
        className="bg-white"
        logo={<Logo variant="simple" color="light" text="Broker" />}
        avatar={showUserDropdown && user ? avatar : null}
      />
      {breadcrumbs && (
        <SubNavbar>
          <Breadcrumb breadcrumbs={breadcrumbs} />
          {!!RightSubNavElement && <div>{RightSubNavElement}</div>}
        </SubNavbar>
      )}
      <div
        id="mainLayoutContainer"
        style={{
          marginTop: navBarOffsetMargin,
          height: `calc(100vh - ${navBarOffsetMargin}px)`,
          overflow: 'scroll'
        }}
      >
        {children}
      </div>
    </div>
  )
}
// hi
// hey
